/// <reference types="@angular/localize" />

import { includeBearerTokenInterceptor, UserActivityService } from "keycloak-angular";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { APP_ROUTES } from "./app/app.routes";
import { AppComponent } from "./app/app.component";
import { importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, withDebugTracing, withRouterConfig } from "@angular/router";
import { providePiensoAuthorization } from "./app/shared/auth/pienso-keycloak-provider";
import { authInterceptor } from "./app/shared/auth/auth.interceptor";
import { notFoundInterceptor } from "./app/shared/notfound.interceptor";

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(BrowserModule),
    providePiensoAuthorization(),
    UserActivityService,
    provideHttpClient(withInterceptors([includeBearerTokenInterceptor, authInterceptor, notFoundInterceptor])),
    provideAnimations(),
    provideRouter(APP_ROUTES, withRouterConfig({ onSameUrlNavigation: "reload" }) /* withDebugTracing() */),
  ],
}).catch((err) => console.error(err));
